
import { createStore, applyMiddleware} from 'redux';  
import { createLogger } from 'redux-logger';
import thunk from 'redux-thunk';
import * as Types from './types';
import reducer from './reducers'


export default function configureStore(apiUrl: string) {
	
	const thunkMiddleware = thunk.withExtraArgument(apiUrl);
	const middlewares = process.env.NODE_ENV === 'development' ?
		applyMiddleware(createLogger(),thunkMiddleware) : applyMiddleware(thunkMiddleware);
	
	return createStore(
		reducer,
		{apiUrl,loadingStep: Types.LoadingStep.NotLoaded },
		middlewares
	);
}





// WEBPACK FOOTER //
// ./src/store/index.ts